import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=3bd7ed5d&scoped=true"
import script from "./Header.ts?vue&type=script&lang=ts&external"
export * from "./Header.ts?vue&type=script&lang=ts&external"
import style0 from "./Header.vue?vue&type=style&index=0&id=3bd7ed5d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd7ed5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd7ed5d')) {
      api.createRecord('3bd7ed5d', component.options)
    } else {
      api.reload('3bd7ed5d', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=3bd7ed5d&scoped=true", function () {
      api.rerender('3bd7ed5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Core/components/Header/Header.vue"
export default component.exports